import '../common.scss';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainSreen';
import Prefooter from '../../components/Prefooter';
import Back from '../../assets/asc.jpg';
import { useOutletContext } from 'react-router-dom';

const MainPage = ({ onFormClick }) => {
  const navigate = useNavigate();
  const { setFormOpen } = useOutletContext();

  return (
    <div className='content'>
      <MainScreen
        tag='For staffing agency owners'
        title={
          <span>
            The AI Growth Partner for <b>Healthcare & Professional Services Staffing</b>
          </span>
        }
        text={`We're not a typical buyer. Our AI platform helps your recruiters make more placements, your clients get better coverage, and your profitability increases. Your team grows, not shrinks.`}
        button='Get a free valuation'
        image={Back}
        onClick={() => setFormOpen('I own a staffing agency')}
      />
      <div className='statsSection'>
        <div className='statsItem'>
          <span className='statsItemCount'>110%</span>
          <span className='statsItemText'>Net recruiter retention incl. new hires for growth</span>
        </div>
        <div className='statsItem'>
          <span className='statsItemCount'>98%</span>
          <span className='statsItemText'>Client retention post-acquisition</span>
        </div>
        <div className='statsItem'>
          <span className='statsItemCount'>3</span>
          <span className='statsItemText'>Acquisitions completed in 2025</span>
        </div>
        <div className='statsItem'>
          <span className='statsItemCount'>6–8 wks</span>
          <span className='statsItemText'>Average LOI to close</span>
        </div>
      </div>
      <div className='cardsSection'>
        <span className='sectionTitle'>We keep your agency in the know and in control</span>
        <span className='sectionTitleText'>
          Pioneers runs a growth-focused acquisitions business for independent staffing agencies
        </span>
        <div className='cardsSectionRow'>
          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.6251C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3856 28.5491 22.5498 28.3775 22.6501L16.3775 29.6501C16.2635 29.7159 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7159 15.6275 29.6501L3.6275 22.6501C3.46992 22.5438 3.35855 22.3817 3.31591 22.1965C3.27326 22.0113 3.30252 21.8168 3.39777 21.6523C3.49302 21.4879 3.64715 21.3657 3.82902 21.3105C4.01089 21.2553 4.20692 21.2712 4.3775 21.3551L16.0025 28.1338L27.6275 21.3551C27.7988 21.2566 28.002 21.2298 28.193 21.2804C28.384 21.3309 28.5473 21.4548 28.6475 21.6251ZM27.625 15.3526L16 22.1313L4.375 15.3526C4.20442 15.2688 4.00839 15.2528 3.82652 15.308C3.64465 15.3632 3.49052 15.4854 3.39527 15.6498C3.30002 15.8143 3.27076 16.0088 3.31341 16.194C3.35605 16.3792 3.46742 16.5413 3.625 16.6476L15.625 23.6476C15.739 23.7134 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7134 16.375 23.6476L28.375 16.6476C28.5326 16.5413 28.6439 16.3792 28.6866 16.194C28.7292 16.0088 28.7 15.8143 28.6047 15.6498C28.5095 15.4854 28.3553 15.3632 28.1735 15.308C27.9916 15.2528 27.7956 15.2688 27.625 15.3526ZM3.25 10.0001C3.25035 9.86875 3.28518 9.73983 3.35098 9.6262C3.41679 9.51257 3.51128 9.41821 3.625 9.35256L15.625 2.35256C15.739 2.28673 15.8683 2.25208 16 2.25208C16.1317 2.25208 16.261 2.28673 16.375 2.35256L28.375 9.35256C28.4881 9.41865 28.5819 9.5132 28.647 9.6268C28.7122 9.7404 28.7465 9.86909 28.7465 10.0001C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5815 28.375 10.6476L16.375 17.6476C16.261 17.7134 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7134 15.625 17.6476L3.625 10.6476C3.51128 10.5819 3.41679 10.4875 3.35098 10.3739C3.28518 10.2603 3.25035 10.1314 3.25 10.0001ZM5.48875 10.0001L16 16.1313L26.5112 10.0001L16 3.87506L5.48875 10.0001Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Growth-Focused</span>
            <span className='cardsSectionItemText'>
              We invest in growth, not cost-cutting. More placements, better fill rates, higher revenue per recruiter.
            </span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.6251C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3856 28.5491 22.5498 28.3775 22.6501L16.3775 29.6501C16.2635 29.7159 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7159 15.6275 29.6501L3.6275 22.6501C3.46992 22.5438 3.35855 22.3817 3.31591 22.1965C3.27326 22.0113 3.30252 21.8168 3.39777 21.6523C3.49302 21.4879 3.64715 21.3657 3.82902 21.3105C4.01089 21.2553 4.20692 21.2712 4.3775 21.3551L16.0025 28.1338L27.6275 21.3551C27.7988 21.2566 28.002 21.2298 28.193 21.2804C28.384 21.3309 28.5473 21.4548 28.6475 21.6251ZM27.625 15.3526L16 22.1313L4.375 15.3526C4.20442 15.2688 4.00839 15.2528 3.82652 15.308C3.64465 15.3632 3.49052 15.4854 3.39527 15.6498C3.30002 15.8143 3.27076 16.0088 3.31341 16.194C3.35605 16.3792 3.46742 16.5413 3.625 16.6476L15.625 23.6476C15.739 23.7134 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7134 16.375 23.6476L28.375 16.6476C28.5326 16.5413 28.6439 16.3792 28.6866 16.194C28.7292 16.0088 28.7 15.8143 28.6047 15.6498C28.5095 15.4854 28.3553 15.3632 28.1735 15.308C27.9916 15.2528 27.7956 15.2688 27.625 15.3526ZM3.25 10.0001C3.25035 9.86875 3.28518 9.73983 3.35098 9.6262C3.41679 9.51257 3.51128 9.41821 3.625 9.35256L15.625 2.35256C15.739 2.28673 15.8683 2.25208 16 2.25208C16.1317 2.25208 16.261 2.28673 16.375 2.35256L28.375 9.35256C28.4881 9.41865 28.5819 9.5132 28.647 9.6268C28.7122 9.7404 28.7465 9.86909 28.7465 10.0001C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5815 28.375 10.6476L16.375 17.6476C16.261 17.7134 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7134 15.625 17.6476L3.625 10.6476C3.51128 10.5819 3.41679 10.4875 3.35098 10.3739C3.28518 10.2603 3.25035 10.1314 3.25 10.0001ZM5.48875 10.0001L16 16.1313L26.5112 10.0001L16 3.87506L5.48875 10.0001Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Transparent</span>
            <span className='cardsSectionItemText'>
              We explain our acquisition process upfront and in real-time, through direct communication channels, 24/7.
            </span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.625C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3855 28.5491 22.5498 28.3775 22.65L16.3775 29.65C16.2635 29.7158 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7158 15.6275 29.65L3.6275 22.65C3.46992 22.5437 3.35855 22.3816 3.31591 22.1964C3.27326 22.0112 3.30252 21.8167 3.39777 21.6523C3.49302 21.4878 3.64715 21.3656 3.82902 21.3104C4.01089 21.2553 4.20692 21.2712 4.3775 21.355L16.0025 28.1337L27.6275 21.355C27.7988 21.2566 28.002 21.2297 28.193 21.2803C28.384 21.3309 28.5473 21.4547 28.6475 21.625ZM27.625 15.3525L16 22.1312L4.375 15.3525C4.20442 15.2687 4.00839 15.2528 3.82652 15.308C3.64465 15.3631 3.49052 15.4853 3.39527 15.6498C3.30002 15.8142 3.27076 16.0087 3.31341 16.1939C3.35605 16.3791 3.46742 16.5412 3.625 16.6475L15.625 23.6475C15.739 23.7133 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7133 16.375 23.6475L28.375 16.6475C28.5326 16.5412 28.6439 16.3791 28.6866 16.1939C28.7292 16.0087 28.7 15.8142 28.6047 15.6498C28.5095 15.4853 28.3553 15.3631 28.1735 15.308C27.9916 15.2528 27.7956 15.2687 27.625 15.3525ZM3.25 10C3.25035 9.86869 3.28518 9.73977 3.35098 9.62614C3.41679 9.51251 3.51128 9.41815 3.625 9.3525L15.625 2.35249C15.739 2.28667 15.8683 2.25201 16 2.25201C16.1317 2.25201 16.261 2.28667 16.375 2.35249L28.375 9.3525C28.4881 9.41859 28.5819 9.51314 28.647 9.62674C28.7122 9.74034 28.7465 9.86902 28.7465 10C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5814 28.375 10.6475L16.375 17.6475C16.261 17.7133 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7133 15.625 17.6475L3.625 10.6475C3.51128 10.5818 3.41679 10.4875 3.35098 10.3739C3.28518 10.2602 3.25035 10.1313 3.25 10ZM5.48875 10L16 16.1312L26.5112 10L16 3.87499L5.48875 10Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Respectful</span>
            <span className='cardsSectionItemText'>
              Your name on the door doesn't change. We preserve the brand and client relationships you've built.
            </span>
          </div>

          <div className='cardsSectionItem'>
            <span className='cardsSectionItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                  d='M28.6475 21.625C28.7475 21.7968 28.7752 22.0012 28.7246 22.1934C28.674 22.3855 28.5491 22.5498 28.3775 22.65L16.3775 29.65C16.2635 29.7158 16.1342 29.7505 16.0025 29.7505C15.8708 29.7505 15.7415 29.7158 15.6275 29.65L3.6275 22.65C3.46992 22.5437 3.35855 22.3816 3.31591 22.1964C3.27326 22.0112 3.30252 21.8167 3.39777 21.6523C3.49302 21.4878 3.64715 21.3656 3.82902 21.3104C4.01089 21.2553 4.20692 21.2712 4.3775 21.355L16.0025 28.1337L27.6275 21.355C27.7988 21.2566 28.002 21.2297 28.193 21.2803C28.384 21.3309 28.5473 21.4547 28.6475 21.625ZM27.625 15.3525L16 22.1312L4.375 15.3525C4.20442 15.2687 4.00839 15.2528 3.82652 15.308C3.64465 15.3631 3.49052 15.4853 3.39527 15.6498C3.30002 15.8142 3.27076 16.0087 3.31341 16.1939C3.35605 16.3791 3.46742 16.5412 3.625 16.6475L15.625 23.6475C15.739 23.7133 15.8683 23.748 16 23.748C16.1317 23.748 16.261 23.7133 16.375 23.6475L28.375 16.6475C28.5326 16.5412 28.6439 16.3791 28.6866 16.1939C28.7292 16.0087 28.7 15.8142 28.6047 15.6498C28.5095 15.4853 28.3553 15.3631 28.1735 15.308C27.9916 15.2528 27.7956 15.2687 27.625 15.3525ZM3.25 10C3.25035 9.86869 3.28518 9.73977 3.35098 9.62614C3.41679 9.51251 3.51128 9.41815 3.625 9.3525L15.625 2.35249C15.739 2.28667 15.8683 2.25201 16 2.25201C16.1317 2.25201 16.261 2.28667 16.375 2.35249L28.375 9.3525C28.4881 9.41859 28.5819 9.51314 28.647 9.62674C28.7122 9.74034 28.7465 9.86902 28.7465 10C28.7465 10.131 28.7122 10.2597 28.647 10.3733C28.5819 10.4869 28.4881 10.5814 28.375 10.6475L16.375 17.6475C16.261 17.7133 16.1317 17.748 16 17.748C15.8683 17.748 15.739 17.7133 15.625 17.6475L3.625 10.6475C3.51128 10.5818 3.41679 10.4875 3.35098 10.3739C3.28518 10.2602 3.25035 10.1313 3.25 10ZM5.48875 10L16 16.1312L26.5112 10L16 3.87499L5.48875 10Z'
                  fill='#003733'
                />
              </svg>
            </span>
            <span className='cardsSectionItemTitle'>Trusted</span>
            <span className='cardsSectionItemText'>
              Experienced team with deep staffing expertise and a track record of growing agencies with AI.
            </span>
          </div>
        </div>
      </div>
      <div className='provenSection'>
        <span className='provenSectionTitle'>Proven results</span>
        <span className='provenSectionText'>
          Across our acquisitions: fill rates up 75%, placements doubled, time to fill cut by 22-43%
        </span>
        <div className='provenSectionContent'>
          <div className='provenSectionCard'>
            <div className='provenSectionCardHeader'>
              <span className='provenSectionCardHeaderTitle'>Texas Tech Staffing Firm</span>
              <span className='provenSectionCardHeaderText'>6-9 month transformation</span>
            </div>
            <div className='provenSectionCardContent'>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>Revenue</span>
                <span className='provenSectionCardCount'>+72%</span>
              </div>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>Annual EBITDA</span>
                <span className='provenSectionCardCount'>Full turnaround</span>
              </div>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>Time to Fill</span>
                <span className='provenSectionCardCount'>-58%</span>
              </div>
            </div>
          </div>

          <div className='provenSectionCard'>
            <div className='provenSectionCardHeader'>
              <span className='provenSectionCardHeaderTitle'>Midwest Healthcare Staffing Agency</span>
              <span className='provenSectionCardHeaderText'>First 8 months post-close</span>
            </div>
            <div className='provenSectionCardContent'>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>Fill Rate</span>
                <span className='provenSectionCardCount'>+68%</span>
              </div>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>EBITDA</span>
                <span className='provenSectionCardCount'>+136%</span>
              </div>
              <div className='provenSectionCardContentRow'>
                <span className='provenSectionCardText'>Time to Fill</span>
                <span className='provenSectionCardCount'>-22%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='processSection'>
        <span className='sectionTitle'>We keep your agency in the know and in control</span>
        <span className='sectionTitleText'>
          Pioneers runs a growth-focused acquisitions business for independent staffing agencies
        </span>
        <div className='processSectionCards'>
          <div className='processSectionCard'>
            <span className='processSectionCardTag' style={{ color: '#AF1D75', backgroundColor: '#FCE6FA' }}>
              30 DAYS PRE-CLOSE
            </span>
            <span className='processSectionCardTitle'>Business as Usual</span>
            <span className='processSectionCardText'>
              Nothing changes for your team or clients. We learn your workflows and build a rollout plan together.
            </span>
          </div>

          <div className='processSectionCard'>
            <span className='processSectionCardTag' style={{ color: '#A75C1B', backgroundColor: '#FFF1CC' }}>
              DAYS 1-60
            </span>
            <span className='processSectionCardTitle'>AI Tools Go Live</span>
            <span className='processSectionCardText'>
              Your team picks which modules to activate. Hands-on training at their pace.
            </span>
          </div>

          <div className='processSectionCard'>
            <span className='processSectionCardTag' style={{ color: '#067566', backgroundColor: '#E0F7F3' }}>
              DAYS 60+
            </span>
            <span className='processSectionCardTitle'>Results Start Showing</span>
            <span className='processSectionCardText'>
              Measurable gains in productivity, fill rates, and revenue. Less admin, more placements.
            </span>
          </div>
        </div>
      </div>
      <div className='howSection'>
        <div className='howBlock'>
          <span className='howBlockTitle'>How we structure deals</span>
          <div className='howBlockPoints'>
            <div className='howBlockPoint'>
              <span className='howBlockPointIcon howBlockPointIconBig'>↗</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>De-risk while preserving upside</span>
                <span className='howBlockPointText'>
                  You share in earnouts tied to AI-driven growth. The better the AI works, the more you earn.
                </span>
              </div>
            </div>

            <div className='howBlockPoint'>
              <span className='howBlockPointIcon howBlockPointIconBig'>$</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>Option to stay invested</span>
                <span className='howBlockPointText'>
                  Roll a portion into the diversified platform and continue building equity alongside us. Potential tax-advantaged
                  structures available.
                </span>
              </div>
            </div>

            <div className='howBlockPoint'>
              <span className='howBlockPointIcon howBlockPointIconBig'>✓</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>Built around what matters to you</span>
                <span className='howBlockPointText'>
                  Upfront cash, ongoing income, growth earnouts. We structure around your priorities.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='howBlock'>
          <span className='howBlockTitle'>Why partner with Pioneers</span>
          <div className='howBlockPoints'>
            <div className='howBlockPoint'>
              <span className='howBlockPointIcon'>✓</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>Your team stays. Your clients stay.</span>
                <span className='howBlockPointText'>We protect the relationships you've spent years building.</span>
              </div>
            </div>

            <div className='howBlockPoint'>
              <span className='howBlockPointIcon'>✓</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>We invest in growth, not cost-cutting.</span>
                <span className='howBlockPointText'>Every agency we've partnered with has grown in year one.</span>
              </div>
            </div>

            <div className='howBlockPoint'>
              <span className='howBlockPointIcon'>✓</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>Stay on or step back. Your call.</span>
                <span className='howBlockPointText'>
                  Keep running the business with better tools, or transition out on a timeline you're comfortable with.
                </span>
              </div>
            </div>

            <div className='howBlockPoint'>
              <span className='howBlockPointIcon'>✓</span>
              <div className='howBlockPointInfo'>
                <span className='howBlockPointTitle'>Your name on the door doesn't change.</span>
                <span className='howBlockPointText'>We keep your brand, your identity, and your reputation intact.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Prefooter
        title='Ready to explore the future of your agency?'
        text='Find out what your agency is worth. No commitment, completely confidential.'
        button='Get a free valuation'
        onClick={() => setFormOpen('I own a staffing agency')}
      />
    </div>
  );
};

export default MainPage;
